import { defineMessages, useIntl } from 'react-intl';

import type { Category } from '@confluence/category-selector';

import { SNIPPET_CATEGORY_IDS } from '../../constants/snippetCategories.ts';

const snippetCategoryI18n = defineMessages({
	allCategory: {
		id: 'snippets.snippet-tab.category.all',
		defaultMessage: 'All',
		description: 'Label for the All category filter in snippet templates',
	},
	myTemplatesCategory: {
		id: 'snippets.snippet-tab.category.my-templates',
		defaultMessage: 'My Templates',
		description: 'Label for the My Templates category filter in snippet templates',
	},
	favoritesCategory: {
		id: 'snippets.snippet-tab.category.favorites',
		defaultMessage: 'Favorites',
		description: 'Label for the Favorites category filter in snippet templates',
	},
});

/**
 * Hook that returns the categories array for snippet filters.
 * @returns Array of Category objects
 */
export const useSnippetFilterCategories = (): Category[] => {
	const intl = useIntl();

	return [
		{ id: SNIPPET_CATEGORY_IDS.ALL, name: intl.formatMessage(snippetCategoryI18n.allCategory) },
		{
			id: SNIPPET_CATEGORY_IDS.MY_TEMPLATES,
			name: intl.formatMessage(snippetCategoryI18n.myTemplatesCategory),
		},
		{
			id: SNIPPET_CATEGORY_IDS.FAVORITES,
			name: intl.formatMessage(snippetCategoryI18n.favoritesCategory),
		},
	];
};
